module.exports = __webpack_public_path__ + "img/weylchem.6a6dc2ea.png";